/**
 * v7.1-hotfix2 — aviso do campo "Referência do token" (Fiscal → Configurações).
 *
 * A situação mostrada é a do nome DIGITADO, conferida na API (`GET /fiscal/configuracao/segredo`).
 * Antes, a tela mostrava a presença do nome SALVO ao lado do nome digitado e dizia
 * "NÃO encontrada no servidor" enquanto o novo nome não era salvo.
 */
import type { SecretRefCheck } from "@cafegestor/shared";

export type SecretHintInput = {
  /** nome digitado */
  value: string | null;
  /** nome salvo na configuração */
  saved: string | null;
  /** presença do nome SALVO (de `secretsPresent`) */
  present: boolean;
  /** conferência do nome digitado (null enquanto não há resposta) */
  check: SecretRefCheck | null;
  /** conferência em andamento */
  checking: boolean;
  prefix: string;
};

export function secretHint(i: SecretHintInput): { hint: string; error?: string } {
  const { value, saved, present, check, checking, prefix } = i;
  if (!value)
    return {
      hint: `Nome da variável no servidor, desta empresa: ${prefix}NOME (o valor nunca fica aqui).`,
    };
  const unsaved = value !== saved;
  if (!check) {
    if (checking) return { hint: "Conferindo no servidor…" };
    if (unsaved) return { hint: "Clique em Salvar para usar esta variável." };
    return present
      ? { hint: "Encontrada no servidor." }
      : { hint: "", error: "NÃO encontrada no servidor." };
  }
  switch (check.status) {
    case "encontrada":
      return {
        hint: unsaved
          ? "Encontrada no servidor. Clique em Salvar para usar esta variável."
          : "Encontrada no servidor.",
      };
    case "formato_invalido":
      return {
        hint: "",
        error: `Nome fora do padrão: ${check.expectedPrefix}NOME (letras maiúsculas, números e _).`,
      };
    case "outra_empresa":
      return {
        hint: "",
        error: `Esta variável não é desta empresa: o nome precisa começar com ${check.expectedPrefix}`,
      };
    case "vazia":
      return {
        hint: "",
        error: "Encontrada no servidor, mas SEM valor: preencha o valor no .env.",
      };
    case "ausente":
      return {
        hint: "",
        error: check.envChangedSinceStart
          ? "NÃO encontrada no servidor: o arquivo .env foi alterado depois que a API iniciou — reinicie a API e o worker."
          : check.envFolder
            ? `NÃO encontrada no servidor. A API leu o .env da pasta "${check.envFolder}": confira se a variável está nesse arquivo (e não em outra pasta do projeto) e reinicie a API e o worker.`
            : "NÃO encontrada no servidor: a API não encontrou o arquivo .env na raiz do projeto.",
      };
  }
}
